import { useMemo } from 'react';
import type { ExternalSignatureReportView } from '@safetyhub/shared';
import { ComposedDocumentBody } from '../reports/composer/ComposedDocumentBody';
import { buildComposerApprovalDataFromExternal } from '../../composer/composerApprovalDataPublic';

export interface ExternalReportContentProps {
  /** 서버 응답의 report (ExternalSignatureReportView) */
  report: ExternalSignatureReportView;
}

/**
 * 외부 서명 페이지 공용 보고서 렌더.
 *
 * 모든 문서가 Composer 양식 문서라(유형 판별 축은 `templateKey`뿐)
 * `ComposedDocumentBody`(상세·공유와 동일한 공용 렌더 코어) 하나로 그린다 — 양식 전용 갈래를 두지 않는다.
 */
export function ExternalReportContent({ report }: ExternalReportContentProps) {
  // 결재란 데이터 — 인쇄 미리보기와 동형으로 report가 바뀔 때만 조립(매 렌더 호출 방지, W-h).
  const approvalData = useMemo(() => buildComposerApprovalDataFromExternal(report), [report]);
  // 상세(ComposerReportDetail)·공유와 동일한 공용 렌더 코어 재사용(파리티). 무인증 경로라 클라 live
  // fetch는 없고, 서버가 상세와 동일 resolver(resolveLiveForReport)로 부착한 liveData blob을 주입한다
  // (live 바인딩 서명 등 공란 방지).
  return (
    <ComposedDocumentBody
      templateSnapshot={report.templateSnapshot ?? undefined}
      templateKey={report.templateKey}
      content={report.content}
      approvalData={approvalData}
      liveData={report.liveData ?? undefined}
    />
  );
}
